const invTerminalHospitalfromdata = [
    {
		inputdata: '',
		title: '终端医院',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: '',
		inputtype: 'selectautocompleteHB',
		width: '650px',
		disabled: false,
		lablewith: '120px',
		options: []
	},
]
export default invTerminalHospitalfromdata;